module.exports = __webpack_public_path__ + "img/视听辅助设备.4345f8a9.png";